import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FieldConfigName} from '../../../models';
import {DateInputDialogComponent} from './date-input-dialog.component';
import {FieldControlMaster} from '../control-master-label-required';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DateInputComponent extends FieldControlMaster implements OnInit {
  @Output() datepickerUpdateControl = new EventEmitter<{ control: FieldConfigName, index: number }>();
  @Output() datepickerDelete = new EventEmitter<number>();
  dialogComponent = DateInputDialogComponent;
  constructor() {
    super();
  }
  ngOnInit(): void {
  }
  onUpdatedControl(object) {
    this.datepickerUpdateControl.emit(object);
  }
  onDeletedControl(index: number) {
    this.datepickerDelete.emit(index);
  }
}
